var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "e-filters",
        {
          attrs: { searching: _vm.fetching },
          on: { search: _vm.filterData, reset: _vm.resetFiltersLocal },
        },
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "5" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "tax-configuration-group-name",
                      type: "text",
                      label: _vm.$t("Nome"),
                      placeholder: _vm.$t("Digite para pesquisar"),
                      autofocus: "",
                    },
                    model: {
                      value: _vm.filters.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "name", $$v)
                      },
                      expression: "filters.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "5" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "tax-configuration-group-ncm",
                      type: "select-searchable",
                      label: _vm.$t("NCM"),
                      placeholder: _vm.$t("Digite para pesquisar"),
                      options: _vm.getComboNcms,
                    },
                    on: { fetchSearch: _vm.ncmSearch },
                    model: {
                      value: _vm.filters.ncm,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "ncm", $$v)
                      },
                      expression: "filters.ncm",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "2" } },
                [
                  _c("FormulateInput", {
                    attrs: {
                      id: "tax-configuration-group-active",
                      type: "vue-select",
                      label: _vm.$t("Status"),
                      options: _vm.statusOptions,
                    },
                    model: {
                      value: _vm.filters.active,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "active", $$v)
                      },
                      expression: "filters.active",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-card-actions",
        {
          attrs: { "action-refresh": "", "show-loading": _vm.fetching },
          on: { refresh: _vm.getData },
        },
        [
          _c(
            "div",
            { attrs: { slot: "title" }, slot: "title" },
            [
              _c("e-page-size-selector", {
                attrs: { "per-page": _vm.paging.pageSize },
                on: { change: _vm.pageSizeChange },
              }),
            ],
            1
          ),
          _c("b-table", {
            ref: "taxConfigurationGroups-table",
            staticClass: "bordered",
            attrs: {
              "show-empty": "",
              responsive: "",
              striped: "",
              "empty-text": _vm.getEmptyTableMessage(
                _vm.$tc("TAX_CONFIGURATION_GROUP.NAME"),
                "female"
              ),
              fields: _vm.fields,
              items: _vm.taxConfigurationGroups,
              "no-local-sorting": "",
              "sort-by": _vm.sorting.sortBy,
              "sort-desc": _vm.sorting.sortDesc,
            },
            on: {
              "update:sortBy": function ($event) {
                return _vm.$set(_vm.sorting, "sortBy", $event)
              },
              "update:sort-by": function ($event) {
                return _vm.$set(_vm.sorting, "sortBy", $event)
              },
              "update:sortDesc": function ($event) {
                return _vm.$set(_vm.sorting, "sortDesc", $event)
              },
              "update:sort-desc": function ($event) {
                return _vm.$set(_vm.sorting, "sortDesc", $event)
              },
              "sort-changed": _vm.getData,
            },
            scopedSlots: _vm._u([
              {
                key: "cell(action)",
                fn: function (row) {
                  return [
                    _c("e-grid-actions", {
                      attrs: {
                        "show-update": _vm.$can(
                          "Update",
                          "TaxConfigurationGroup"
                        ),
                        "show-delete": _vm.$can(
                          "Delete",
                          "TaxConfigurationGroup"
                        ),
                        buttons: _vm.gridActionButtons,
                      },
                      on: {
                        update: function ($event) {
                          return _vm.updateTaxConfigurationGroup(row.item)
                        },
                        delete: function ($event) {
                          return _vm.deleteTaxConfigurationGroup(row.item)
                        },
                        "associate-skus": function ($event) {
                          return _vm.openSkuModal(row.item)
                        },
                      },
                    }),
                  ]
                },
              },
              {
                key: "cell(skuCount)",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _vm.$can("Update", "TaxConfigurationGroup")
                      ? _c(
                          "b-link",
                          {
                            attrs: { title: _vm.$t("Associar produtos") },
                            on: {
                              click: function ($event) {
                                return _vm.openSkuModal(item)
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(item.skuCount) + " ")]
                        )
                      : _c("span", [_vm._v(_vm._s(item.skuCount))]),
                  ]
                },
              },
              {
                key: "cell(active)",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _c("e-status-badge", { attrs: { status: item.active } }),
                  ]
                },
              },
            ]),
          }),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c("e-pagination-summary", {
                    attrs: {
                      "current-page": _vm.paging.currentPage,
                      "per-page": _vm.paging.pageSize,
                      total: _vm.paging.rowCount,
                      "total-on-page": _vm.paging.rowsInCurrentPage,
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c("b-pagination", {
                    attrs: {
                      align: "right",
                      "total-rows": _vm.paging.rowCount,
                      "per-page": _vm.paging.pageSize,
                      "aria-controls": "taxConfigurationGroups-table",
                    },
                    on: { change: _vm.pageChange },
                    model: {
                      value: _vm.paging.currentPage,
                      callback: function ($$v) {
                        _vm.$set(_vm.paging, "currentPage", $$v)
                      },
                      expression: "paging.currentPage",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.$can("Create", "TaxConfigurationGroup")
        ? _c("FAB", {
            attrs: { "main-tooltip": _vm.$t("Adicionar Exceção Fiscal") },
            on: { click: _vm.create },
          })
        : _vm._e(),
      _c("tax-configuration-group-sku-modal", {
        ref: "skuModal",
        on: { saved: _vm.getData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }